import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// CSS
import "../../../css/checkout-login.css";

// State
import { customerLogin, clearErrors } from "../../../store/actions/user";
import { setActiveCheckoutSection } from "../../../store/actions/checkout";

// Util
import { checkoutSignIn as checkoutSignInGA } from "../../../utils/google-analytics";

class CustomerLogin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: "",
			password: ""
		};

		this.componentCleanup = this.componentCleanup.bind(this);
	}

	componentDidMount() {
		window.addEventListener("beforeunload", this.componentCleanup);
	}

	componentCleanup() {
		this.props.clearErrors();
		window.removeEventListener("beforeunload", this.componentCleanup);
	}

	componentWillUnmount() {
		this.componentCleanup();
	}

	handleInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	handleKeyPress(event, item_id) {
		if (event.key === "Enter") {
			this.handleSubmit(event);
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.customerLogin(this.state.email, this.state.password).then(result => {
			if (result !== undefined) {
				checkoutSignInGA(this.props.items);
				this.props.setActiveCheckoutSection("delivery");
			}
		});
	}

	render() {
		return (
			<form name="customer-login">
				<h2>Sign into your account</h2>
				<Link className="link--decorated" to={"/customer/create-account"}>
					Create an online account
				</Link>

				<div className="form-field">
					{this.props.errors.email && this.props.loginTypeAttempted === "customer" && <div className="error msg_animate">{this.props.errors.email}</div>}
					<input type="email" name="email" value={this.state.email} placeholder="email@provider.com" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} />
				</div>
				<div className="form-field">
					{this.props.errors.password && this.props.loginTypeAttempted === "customer" && <div className="error msg_animate">{this.props.errors.password}</div>}
					<input type="password" name="password" value={this.state.password} placeholder="" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} />
				</div>

				<div className="action-elements">
					{this.props.errors.general && this.props.loginTypeAttempted === "customer" && <div className="error msg_animate">{this.props.errors.general}</div>}
					<Link to={"/customer/forgot-password"}>Forgot Password?</Link>
					<button className="btn submit-btn" name="submit" value="submit" onClick={e => this.handleSubmit(e)}>
						<span>Sign In</span>
					</button>
				</div>
			</form>
		);
	}
}

const mapStateToProps = state => {
	return {
		errors: state.user.errors,
		loginTypeAttempted: state.user.loginTypeAttempted,
		isLoading: state.user.isLoading,
		items: state.cart.items
	};
};

export default connect(mapStateToProps, { customerLogin, clearErrors, setActiveCheckoutSection })(CustomerLogin);



// WEBPACK FOOTER //
// ./src/components/checkout/login/CustomerLogin.js